import React, {ReactElement} from 'react';
import {useMedia} from "@hooks/ui/useMedia";
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide/Slide';

const HideOnScroll = ({children}: {
    children: ReactElement
}) => {

    const {isDesktop} = useMedia()
    const trigger = useScrollTrigger();

    if (isDesktop) {
        return children
    }
    return (
        <Slide
            appear={false}
            direction="down"
            in={!trigger}
        >
            {children}
        </Slide>
    );
};


export default HideOnScroll;